function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import app from '@/admin/Bits/elements';
import Rest from '@/admin/Bits/Rest';
import { applyFilters, addFilter, addAction, doAction, removeAllActions } from '@wordpress/hooks';
var moment = require('moment');
require('moment/locale/en-gb');
moment.locale('en-gb');
var appStartTime = new Date();
var FluentFramework = /*#__PURE__*/function () {
  function FluentFramework() {
    _classCallCheck(this, FluentFramework);
    this.doAction = doAction;
    this.addFilter = addFilter;
    this.addAction = addAction;
    this.applyFilters = applyFilters;
    this.removeAllActions = removeAllActions;
    //
    this.$rest = Rest;
    this.appVars = window.fluentFrameworkAdmin;
    this.app = this.extendVueConstructor();
  }
  return _createClass(FluentFramework, [{
    key: "extendVueConstructor",
    value: function extendVueConstructor() {
      var self = this;
      app.mixin({
        methods: {
          addFilter: addFilter,
          applyFilters: applyFilters,
          doAction: doAction,
          addAction: addAction,
          removeAllActions: removeAllActions,
          longLocalDate: self.longLocalDate,
          longLocalDateTime: self.longLocalDateTime,
          dateTimeFormat: self.dateTimeFormat,
          localDate: self.localDate,
          ucFirst: self.ucFirst,
          ucWords: self.ucWords,
          slugify: self.slugify,
          moment: moment,
          $get: self.$get,
          $post: self.$post,
          $del: self.$del,
          $put: self.$put,
          $patch: self.$patch,
          $handleError: self.handleError,
          $saveData: self.saveData,
          $getData: self.getData,
          $timeDiff: self.humanDiffTime,
          $waitingTime: self.waitingTime,
          convertToText: self.convertToText,
          $setTitle: function $setTitle(title) {
            document.title = title;
          }
        }
      });
      return app;
    }
  }, {
    key: "getExtraComponents",
    value: function getExtraComponents() {
      return {
        'ticket-header': {
          template: "<h1>OK</h1>"
        }
      };
    }
  }, {
    key: "registerBlock",
    value: function registerBlock(blockLocation, blockName, block) {
      this.addFilter(blockLocation, this.appVars.slug, function (components) {
        components[blockName] = block;
        return components;
      });
    }
  }, {
    key: "registerTopMenu",
    value: function registerTopMenu(title, route) {
      if (!title || !route.name || !route.path || !route.component) {
        return;
      }
      this.addFilter('fluent_framework_top_menus', this.appVars.slug, function (menus) {
        menus = menus.filter(function (m) {
          return m.route !== route.name;
        });
        menus.push({
          route: route.name,
          title: title
        });
        return menus;
      });
      this.addFilter('fluent_framework_global_routes', this.appVars.slug, function (routes) {
        routes = routes.filter(function (r) {
          return r.name !== route.name;
        });
        routes.push(route);
        return routes;
      });
    }
  }, {
    key: "$get",
    value: function $get(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Rest.get(url, options);
    }
  }, {
    key: "$post",
    value: function $post(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Rest.post(url, options);
    }
  }, {
    key: "$del",
    value: function $del(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Rest["delete"](url, options);
    }
  }, {
    key: "$put",
    value: function $put(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Rest.put(url, options);
    }
  }, {
    key: "$patch",
    value: function $patch(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Rest.patch(url, options);
    }
  }, {
    key: "dateTimeFormat",
    value: function dateTimeFormat(date, format) {
      var dateString = date === undefined ? null : date;
      var dateObj = moment(dateString);
      return dateObj.isValid() ? dateObj.format(format) : null;
    }
  }, {
    key: "localDate",
    value: function localDate(date) {
      return moment.utc(date).local();
    }
  }, {
    key: "longLocalDate",
    value: function longLocalDate(date) {
      return this.dateTimeFormat(date, 'ddd, DD MMM, YYYY');
    }
  }, {
    key: "saveData",
    value: function saveData(key, data) {
      var existingData = window.localStorage.getItem('__fluentsupport_data');
      if (!existingData) {
        existingData = {};
      } else {
        existingData = JSON.parse(existingData);
      }
      existingData[key] = data;
      window.localStorage.setItem('__fluentsupport_data', JSON.stringify(existingData));
    }
  }, {
    key: "getData",
    value: function getData(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var existingData = window.localStorage.getItem('__fluentsupport_data');
      existingData = JSON.parse(existingData);
      if (!existingData) {
        return defaultValue;
      }
      if (existingData[key]) {
        return existingData[key];
      }
      return defaultValue;
    }
  }, {
    key: "longLocalDateTime",
    value: function longLocalDateTime(date) {
      return this.dateTimeFormat(date, 'ddd, DD MMM, YYYY hh:mm:ssa');
    }
  }, {
    key: "ucFirst",
    value: function ucFirst(text) {
      return text[0].toUpperCase() + text.slice(1).toLowerCase();
    }
  }, {
    key: "ucWords",
    value: function ucWords(text) {
      return (text + '').replace(/^(.)|\s+(.)/g, function ($1) {
        return $1.toUpperCase();
      });
    }
  }, {
    key: "slugify",
    value: function slugify(text) {
      return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\\-]+/g, '') // Remove all non-word chars
      .replace(/\\-\\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }, {
    key: "handleError",
    value: function handleError(response) {
      if (response.responseJSON) {
        response = response.responseJSON;
      }
      var errorMessage = '';
      if (typeof response === 'string') {
        errorMessage = response;
      } else if (response && response.message) {
        errorMessage = response.message;
      } else {
        errorMessage = this.convertToText(response);
      }
      if (!errorMessage) {
        errorMessage = 'Something is wrong!';
      }
      this.$notify({
        type: 'error',
        title: 'Error',
        message: errorMessage,
        offset: 32,
        dangerouslyUseHTMLString: true
      });
    }
  }, {
    key: "convertToText",
    value: function convertToText(obj) {
      var string = [];
      if (_typeof(obj) === 'object' && obj.join === undefined) {
        for (var prop in obj) {
          string.push(this.convertToText(obj[prop]));
        }
      } else if (_typeof(obj) === 'object' && !(obj.join === undefined)) {
        for (var _prop in obj) {
          string.push(this.convertToText(obj[_prop]));
        }
      } else if (typeof obj === 'function') {} else if (typeof obj === 'string') {
        string.push(obj);
      }
      return string.join('<br />');
    }
  }, {
    key: "humanDiffTime",
    value: function humanDiffTime(date) {
      var dateString = date === undefined ? null : date;
      if (!dateString) {
        return '';
      }
      var endTime = new Date();
      var timeDiff = endTime - appStartTime; // in ms
      var dateObj = moment(dateString);
      return dateObj.from(moment(window.fluentFrameworkAdmin.server_time).add(timeDiff, 'milliseconds'));
    }
  }, {
    key: "waitingTime",
    value: function waitingTime(time1, time2) {
      if (!time2 || !time1) {
        return '';
      }
      time1 = moment(time1);
      time2 = moment(time2);
      return time2.from(time1);
    }
  }]);
}();
export { FluentFramework as default };